import * as React from 'react';
import { withTranslation  } from 'react-i18next';
import * as ViewManagementModule from '../../../Modules/ViewManagementModule';
import * as Dictionary from './../../../Models/Dictionary';
import { connect } from 'react-redux';
import moment from 'moment';

export type State = {
    languagesMenuVisible: boolean;
};

export type Props = {
    type?: 'LOGIN' | 'REGULAR';
};

export type ConnectedProps = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
};

export type ConnectedDispatch = {
    setLanguage: Function;
    i18n: any;
    t: Function;
    setActivePage: Function;
};

class LanguageSwitcher extends React.Component<Props & ConnectedProps & ConnectedDispatch, State> {
    constructor(props: Props & ConnectedProps & ConnectedDispatch) {
        super(props);
        this.state = {
            languagesMenuVisible: false
        };
    }
    public render() {
        const { t, viewManagementStore, setLanguage, i18n } = this.props;
        const { languagesMenuVisible } = this.state;
        let ActiveLanguageDetails;
        const ActiveLanguage = Dictionary.LanguageCountryCodesReverse.get(viewManagementStore.activeLanguage);
        if (ActiveLanguage) {
            ActiveLanguageDetails = Dictionary.LanguagesDetails.get(ActiveLanguage);
        }
        if (ActiveLanguageDetails) {
            return (
                <li
                    className="singlemenuitem singlemenuitem--lang"
                    onMouseOver={() => this.setState({ languagesMenuVisible: true })}
                    onMouseLeave={() => this.setState({ languagesMenuVisible: false })}
                >
                    <span className="fake-a">
                        <div className={`singlemenuitem__inner ${viewManagementStore.sidebarMenuExpanded ? 'singlemenuitem__inner-expanded' : ''}`}>
                            <img src={ActiveLanguageDetails.iconSrc} alt={t(ActiveLanguageDetails.title)} title={t(ActiveLanguageDetails.title)} />
                            {(viewManagementStore.sidebarMenuExpanded || this.props.type === 'LOGIN') && <span className="singlemenuitem__title">{t(ActiveLanguageDetails.title)}</span>}
                        </div>
                    </span>
                    {languagesMenuVisible && (
                        <div className="singlemenuitem--lang__wrapper">
                            <ul>
                                {Dictionary.LanguagesMenu.map((lang: ViewManagementModule.EnumTypes.Languages, idx: number) => {
                                    const page = Dictionary.LanguagesDetails.get(lang);
                                    if (lang !== ActiveLanguage && page !== undefined) {
                                        return (
                                            <li
                                                key={idx}
                                                onClick={() => {
                                                    setLanguage(page.countryCode);
                                                    i18n.changeLanguage(page.countryCode);
                                                    moment.updateLocale(page.countryCode, null);
                                                    this.setState({
                                                        languagesMenuVisible: false
                                                    });
                                                }}
                                            >
                                                <span className="fake-a">
                                                    <div className={`singlemenuitem__inner ${viewManagementStore.sidebarMenuExpanded ? 'singlemenuitem__inner-expanded' : ''}`}>
                                                        <img src={page.iconSrc} alt={t(page.title)} title={t(page.title)} />
                                                        {(viewManagementStore.sidebarMenuExpanded || this.props.type === 'LOGIN') && <span className="singlemenuitem__title">{t(page.title)}</span>}
                                                    </div>
                                                </span>
                                            </li>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </ul>
                        </div>
                    )}
                </li>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore
    };
}

function mapDispachToProps(dispatch: any) {
    return {
        setLanguage: (lang: string) => dispatch(ViewManagementModule.Actions.setLanguage(lang))
    };
}
/**
 * Pojedynczy element głownego menu aplikacji
 */
export default withTranslation ('mainMenu')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(LanguageSwitcher) as React.ComponentType<any>
) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/Layout/LanguageSwitcher/LanguageSwitcher.tsx